import React from "react";

type AllergensSectionProps = {
  allergens: string[];
  isFixedSideItem?: boolean;
};

export default function AllergensSection({
  allergens,
  isFixedSideItem = false,
}: AllergensSectionProps): JSX.Element {
  return (
    <div>
      <b>{isFixedSideItem ? "Side item allergens" : "Allergens"}: </b>
      {allergens.map((allergen, index, {length}) => (
        <span key={allergen}>
          {allergen}
          {index < length - 1 && (index == length - 2 ? " and " : ", ")}
        </span>
      ))}
    </div>
  );
}
